export function formatPrice(value: number | null | undefined, showSign = false): string {
  if (value == null) return '—';
  const num = Number(value);
  const absValue = '$' + Math.abs(Math.round(num)).toLocaleString();
  if (showSign) {
    return num >= 0 ? `+${absValue}` : `−${absValue}`;
  }
  return num >= 0 ? absValue : `−${absValue}`;
}

export function formatPriceWithCents(value: number | null | undefined): string {
  if (value == null) return '—';
  return '$' + Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPercent(value: number | null | undefined): string {
  if (value == null) return '—';
  const sign = value >= 0 ? '+' : '';
  return sign + Number(value).toFixed(2) + '%';
}

export function formatDate(date: Date): string {
  return date.toISOString().split('T')[0];
}

export function formatVolume(value: number | null | undefined): string {
  if (value == null) return '—';
  return value.toLocaleString();
}
